import { useCallback, useState } from 'react';

export const usePlayVideoManuallyOnError = (
  introVideoRef: React.RefObject<HTMLVideoElement>
) => {
  const [isError, setIsError] = useState(false);

  return {
    onClick: useCallback(() => {
      if (isError) {
        introVideoRef.current?.play();
      }
    }, [isError, introVideoRef]),
    onVideoError: () => setIsError(true),
  };
};
